//'use strict';
//function get(url) {

//    // Creating a promise
//    var promise = new Promise(function (resolve, reject) {

//        // Instantiates the XMLHttpRequest
//        var client = new XMLHttpRequest();

//        client.open('GET', url);
//        client.send();

//        client.onload = function () {
//            if (this.status >= 200 && this.status < 300) {
//                // Performs the function "resolve" when this.status is equal to 2xx
//                resolve(this.response);
//            } else {
//                // Performs the function "reject" when this.status is different than 2xx
//                reject(this.statusText);
//            }
//        };
//        client.onerror = function () {
//            reject(this.statusText);
//        };
//    });

//    // Return the promise
//    return promise;
//}